import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
};

export const schemaUserResolver_GetSchufaAccess = z.boolean();

export type SchemaUserResolver_GetSchufaAccess = z.infer<typeof schemaUserResolver_GetSchufaAccess>;

export type UserResolver_GetSchufaAccess = Resolver<Arguments, SchemaUserResolver_GetSchufaAccess>;
